import { useTheme } from '@mui/material';
import React from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

function StorageDonutChart({ usage }) {
  const { t } = useTranslation();
  const isDarkTheme = useTheme().palette.mode === 'dark';

  return (
    <Chart
      type='radialBar'
      series={[usage]}
      options={{
        labels: [t('view.userCaps.storageUsage')],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 15,
              size: '70%',
            },

            dataLabels: {
              showOn: 'always',
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '13px',
              },
              value: {
                color: isDarkTheme ? '#ffffffff' : "#000",
                fontSize: '30px',
                show: true,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
      }}
    />
  );
}

export default StorageDonutChart;
